var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function({ on, attrs }) {
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    _vm._b(
                      {
                        class: _vm.btnClass,
                        attrs: {
                          small: _vm.small,
                          fab: _vm.fab,
                          color: _vm.color,
                          dark: _vm.dark,
                          rounded: _vm.rounded,
                          outlined: _vm.outlined
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("click")
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    on
                  ),
                  [_vm._t("default")],
                  2
                )
              ]
            }
          }
        ],
        null,
        true
      )
    },
    [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }